export default "__VITE_ASSET__DmtEb$Kn__"